import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _createClass from "@babel/runtime/helpers/createClass";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React from 'react';
import { Button, Flex, Haldor__Block, Icon } from '@haldor/ui';
import DisplayResource from './DisplayResource';
import GoalMatrixForm from './GoalMatrixForm';
import SelectCoursesForm from './SelectCoursesForm';
import SelectMatricesForm from './SelectMatricesForm';
import OnlyFeedbackForm from './OnlyFeedbackForm';
import DisplayOnlyFeedback from './DisplayOnlyFeedback';

var AssessmentBlock = /*#__PURE__*/function (_Haldor__Block) {
  _inherits(AssessmentBlock, _Haldor__Block);

  var _super = _createSuper(AssessmentBlock);

  function AssessmentBlock(_props) {
    var _this;

    _classCallCheck(this, AssessmentBlock);

    _this = _super.call(this, _props);

    _defineProperty(_assertThisInitialized(_this), "addCoursePart", function (event) {
      event.preventDefault();

      _this.addResource('Haldor.Blocks.AssessmentBlock.ShowModal', {
        visible: true
      });
    });

    _defineProperty(_assertThisInitialized(_this), "addGoalMatrix", function (event) {
      event.preventDefault();

      _this.removeFeedBackOnlyResource();

      _this.addResource(_this.PART_RESOURCE_TYPE, {
        status: 'Started',
        referenceId: '',
        referenceType: 'assessmentGoal',
        value: {
          id: 0,
          visibleToStudent: true,
          visibleToGuardian: true,
          title: '',
          rows: []
        },
        permissions: [{
          referenceType: 'ASSESSMENTBLOCKPART',
          target: 'STUDENT',
          level: 'READ'
        }, {
          referenceType: 'ASSESSMENTBLOCKPART',
          target: 'GUARDIAN',
          level: 'READ'
        }, {
          referenceType: 'ASSESSMENTFEEDBACK',
          target: 'GUARDIAN',
          level: 'READ'
        }, {
          referenceType: 'ASSESSMENTFEEDBACK',
          target: 'STUDENT',
          level: 'READ'
        }]
      });
    });

    _defineProperty(_assertThisInitialized(_this), "addFeedBackOnlyResource", function () {
      _this.addResource(_this.PART_RESOURCE_TYPE, {
        status: 'Started',
        referenceId: '0',
        referenceType: 'assessmentonlyfeedback',
        assessmentBlockPartRows: [],
        value: null,
        permissions: [{
          referenceType: 'ASSESSMENTFEEDBACK',
          target: 'GUARDIAN',
          level: 'READ'
        }, {
          referenceType: 'ASSESSMENTFEEDBACK',
          target: 'STUDENT',
          level: 'READ'
        }]
      });
    });

    _defineProperty(_assertThisInitialized(_this), "removeFeedBackOnlyResource", function () {
      var foundExisting = _this.getResources().find(function (resource) {
        return resource.referenceType == 'assessmentonlyfeedback';
      });

      if (foundExisting != null) {
        _this.removeResource(foundExisting);

        return true;
      }
    });

    _defineProperty(_assertThisInitialized(_this), "removeResourceFromBlock", function (resource) {
      _this.removeResource(resource);

      var assessmentBlockPart = _this.getResources().find(function (resource) {
        return resource['@odata.type'] == _this.PART_RESOURCE_TYPE;
      });

      if (assessmentBlockPart == null && _this.name == "Haldor.Blocks.AssessmentBlock") {
        _this.addFeedBackOnlyResource();
      }
    });

    _defineProperty(_assertThisInitialized(_this), "addCourses", function (values) {
      _this.removeFeedBackOnlyResource();

      values.forEach(function (course) {
        _this.addResource(_this.PART_RESOURCE_TYPE, {
          status: 'Started',
          referenceId: '',
          referenceType: 'matrix',
          assessmentBlockPartRows: [],
          value: course,
          permissions: [{
            referenceType: 'ASSESSMENTFEEDBACK',
            target: 'GUARDIAN',
            level: 'READ'
          }, {
            referenceType: 'ASSESSMENTFEEDBACK',
            target: 'STUDENT',
            level: 'READ'
          }]
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "goalMatrixChange", function (goalMatrix) {
      if (goalMatrix.index != null) {
        var foundExisting = _this.getResources().find(function (resource) {
          return resource.index == goalMatrix.index;
        });

        if (foundExisting != null) {
          var currentIndex = foundExisting.index;

          _this.removeResource(foundExisting);

          _this.addResource(_this.PART_RESOURCE_TYPE, goalMatrix, currentIndex);

          return true;
        }
      }

      _this.addResource(_this.PART_RESOURCE_TYPE, goalMatrix);
    });

    _defineProperty(_assertThisInitialized(_this), "courseChange", function (course) {
      if (course == null || course.value == null) {
        return false;
      }

      var foundExisting = _this.getResources().find(function (resource) {
        var _resource$value;

        return ((_resource$value = resource.value) === null || _resource$value === void 0 ? void 0 : _resource$value.id) == course.value.id;
      });

      if (foundExisting != null) {
        var currentIndex = foundExisting.index;

        _this.removeResource(foundExisting);

        _this.addResource(_this.PART_RESOURCE_TYPE, course, currentIndex);

        return true;
      }

      _this.addResource(_this.PART_RESOURCE_TYPE, course);
    });

    _defineProperty(_assertThisInitialized(_this), "onlyFeedbackChange", function (onlyFeedback) {
      var foundExisting = _this.getResources().find(function (resource) {
        return resource.referenceType == onlyFeedback.referenceType;
      });

      if (foundExisting != null) {
        var currentIndex = foundExisting.index;

        _this.removeResource(foundExisting);

        _this.addResource(_this.PART_RESOURCE_TYPE, onlyFeedback, currentIndex);

        return true;
      }
    });

    _defineProperty(_assertThisInitialized(_this), "edit", function (props) {
      var translate = _this.api.getEditor().getProp('translate');

      var disabled = false;
      var addGoalsDisabled = false;
      var resources = JSON.parse(JSON.stringify(props.resources));

      if (_this.api.getEditor().getProp('assessmentFeedbackParts') != null && _this.api.getEditor().getProp('assessmentFeedbackParts').length > 0) {
        addGoalsDisabled = true;
      }

      ;

      if (_this.api.getEditor().getProp('disableRows') != null) {
        disabled = props.resources.find(function (resource) {
          var _resource$assessmentB;

          return ((_resource$assessmentB = resource.assessmentBlockPartRows) === null || _resource$assessmentB === void 0 ? void 0 : _resource$assessmentB.findIndex(function (row) {
            return _this.api.getEditor().getProp('disableRows').includes(row.id);
          })) > -1;
        }) != null;
      }

      var showModal = props.resources.find(function (resource) {
        return resource['@odata.type'] == 'Haldor.Blocks.AssessmentBlock.ShowModal';
      });
      var goalParts = resources.filter(function (resource) {
        return resource['@odata.type'] == _this.PART_RESOURCE_TYPE && resource.referenceType == 'assessmentGoal';
      });
      var feedbackParts = resources.filter(function (resource) {
        return resource['@odata.type'] == _this.PART_RESOURCE_TYPE && resource.referenceType == 'assessmentonlyfeedback';
      });
      var courses = resources.filter(function (resource) {
        return resource['@odata.type'] == _this.PART_RESOURCE_TYPE && resource.referenceType == 'matrix';
      });
      var clarifications = resources.filter(function (resource) {
        return resource['@odata.type'] == _this.PART_RESOURCE_TYPE && resource.referenceType == 'assessmentClarification';
      });
      return /*#__PURE__*/React.createElement("div", {
        className: "block--assessment-block"
      }, showModal != null ? /*#__PURE__*/React.createElement(SelectCoursesForm, {
        onClose: function onClose() {
          return _this.removeResource(showModal);
        },
        skipCourses: courses.map(function (course) {
          return course.value.id;
        }),
        onSubmit: function onSubmit(values) {
          _this.removeResource(showModal);

          _this.addCourses(values);
        }
      }) : null, /*#__PURE__*/React.createElement("div", {
        className: "goal-matrix"
      }, goalParts.map(function (part, index) {
        return /*#__PURE__*/React.createElement(GoalMatrixForm, {
          key: index,
          part: part,
          course: courses,
          onChange: _this.goalMatrixChange,
          onRemove: function onRemove() {
            return _this.removeResourceFromBlock(part);
          },
          assessmentType: _this.assessmentType,
          disableRows: _this.api.getEditor().getProp('disableRows'),
          disabled: disabled
        });
      }), courses.map(function (part, index) {
        return /*#__PURE__*/React.createElement(SelectMatricesForm, {
          key: 'matrix' + index,
          part: part,
          course: part.value,
          onChange: _this.courseChange,
          onRemove: function onRemove() {
            return _this.removeResourceFromBlock(part);
          },
          clarifications: clarifications,
          assessmentType: _this.assessmentType,
          disableRows: _this.api.getEditor().getProp('disableRows'),
          disabled: disabled
        });
      }), feedbackParts.map(function (part, index) {
        return /*#__PURE__*/React.createElement(OnlyFeedbackForm, {
          part: part,
          onChange: _this.onlyFeedbackChange
        });
      })), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Flex, {
        center: true
      }, /*#__PURE__*/React.createElement(Button, {
        type: "secondary",
        disabled: goalParts.length > 0 || addGoalsDisabled,
        onClick: _this.addGoalMatrix,
        style: {
          marginRight: '.55rem'
        }
      }, /*#__PURE__*/React.createElement(Icon, {
        name: "Plus"
      }), " ", translate('Add goal')), /*#__PURE__*/React.createElement(Button, {
        type: "secondary",
        disabled: disabled || addGoalsDisabled,
        onClick: _this.addCoursePart
      }, /*#__PURE__*/React.createElement(Icon, {
        name: "Plus"
      }), " ", translate('Add knowledge requirement')))));
    });

    _defineProperty(_assertThisInitialized(_this), "consume", function (props) {
      var resources = JSON.parse(JSON.stringify(props.resources));

      var goals = _toConsumableArray(resources).filter(function (resource) {
        return resource['@odata.type'] == _this.PART_RESOURCE_TYPE && resource.referenceType == 'assessmentGoal';
      });

      var courses = _toConsumableArray(resources).filter(function (resource) {
        return resource['@odata.type'] == _this.PART_RESOURCE_TYPE && resource.referenceType == 'matrix';
      });

      var clarifications = _toConsumableArray(resources).filter(function (resource) {
        return resource['@odata.type'] == _this.PART_RESOURCE_TYPE && resource.referenceType == 'assessmentClarification';
      });

      var feedbackParts = resources.filter(function (resource) {
        return resource['@odata.type'] == _this.PART_RESOURCE_TYPE && resource.referenceType == 'assessmentonlyfeedback';
      });
      return /*#__PURE__*/React.createElement("div", {
        className: "block--assessment-block consume"
      }, /*#__PURE__*/React.createElement("div", {
        className: "display-matrix"
      }, goals.map(function (resource) {
        return /*#__PURE__*/React.createElement(DisplayResource, {
          resource: resource,
          block: _assertThisInitialized(_this),
          key: resource.id,
          course: courses
        });
      }), courses.map(function (resource) {
        return /*#__PURE__*/React.createElement(DisplayResource, {
          resource: resource,
          block: _assertThisInitialized(_this),
          key: resource.id,
          clarifications: clarifications
        });
      }), feedbackParts.map(function (resource, index) {
        return /*#__PURE__*/React.createElement(DisplayOnlyFeedback, {
          block: _assertThisInitialized(_this),
          part: resource
        });
      })));
    });

    _this.PART_RESOURCE_TYPE = 'Haldor.Blocks.AssessmentBlockPart';

    _this.registerResourceType(_this.PART_RESOURCE_TYPE, {
      status: 'string',
      referenceId: 'string',
      referenceType: 'string',
      value: 'object' // permissions: 'object'

    });

    _this.registerResourceType('Haldor.Blocks.AssessmentBlock.ShowModal', {
      visible: 'boolean'
    });

    _this.registerResourceType('assessmenttype', {});

    return _this;
  }

  return _createClass(AssessmentBlock);
}(Haldor__Block);

export default AssessmentBlock;